import React from 'react';
interface ContentSectionProps {
  title: string;
  content: ReactNode;
  bgColor?: string;
  titleClass?: string;
  containerClass?: string;
}
export function ContentSection({
  title,
  content,
  bgColor = 'bg-white',
  titleClass = 'text-3xl md:text-4xl text-gray-900',
  containerClass = ''
}: ContentSectionProps) {
  // Function to highlight specific terms in red
  const highlightTerms = (text: string) => {
    const terms = ['nervous system', 'interoceptive anxiety', 'anxiety', 'trauma', 'grief', 'emotional overwhelm', 'Vagus nerve', 'vagus nerve'];
    let processedText = text;
    terms.forEach(term => {
      const regex = new RegExp(`(${term})`, 'gi');
      processedText = processedText.replace(regex, '<span class="text-red-600">$1</span>');
    });
    return <span dangerouslySetInnerHTML={{
      __html: processedText
    }} data-id="element-248" />;
  };
  return <section className={`w-full py-6 ${bgColor} rounded-lg my-5 ${containerClass}`} data-id="element-249">
      <div className="max-w-3xl mx-auto" data-id="element-250">
        <h2 className={`font-bold mb-6 leading-tight text-center ${titleClass}`} data-id="element-251">
          {highlightTerms(title)}
        </h2>
        <div className="text-xl font-medium" data-id="element-252">{content}</div>
      </div>
    </section>;
}